import { BaseModel } from "sjs-base-model";

export default class DropdownOptionModel extends BaseModel {
    public readonly value: string = "";
    public readonly description: string = "";

    constructor(data: Partial<DropdownOptionModel>) {
        super();

        this.update(data);
    }
}
